#import "../fragments/chat-settings-engagement-bar-fragment.graphql"

query GetChatSettingsEngagementBar {
    chatSettings {
        ...ChatSettingsEngagementBarFragment
    }
}
